"use client";

import { useCallback } from "react";
import { useFormContext } from "@/context/FormContext";
import { useGlobalStateContext } from "@/context/GlobalContext";
import {
  NewProductInformationFormData,
  ProductIdeaData,
  VendorInformationFormData,
} from "@/context/data";

/** Clears shopping-list product form state and selected idea (e.g. when leaving detail for list). */
export const useShoppingListFormReset = () => {
  const {
    setProductIdeaData,
    setNewProductInformationForm,
    setProductInformationFormErrors,
    setVendorInformationFormErrors,
    setVendorInformationForms,
    setSelectedIdea,
  } = useFormContext();
  const {
    setCommentCount,
    setVendorList,
    setActiveVendorTab,
    setHasVendorInformationFormsSubmitted,
    setIsCommentVisible,
    setShowCommentsNLogs,
    setCommentsComponentActive,
  } = useGlobalStateContext();

  const resetFormState = useCallback(() => {
    setProductIdeaData(ProductIdeaData);
    setNewProductInformationForm(prevForm => ({
      ...NewProductInformationFormData,
      developer: prevForm.developer || "",
    }));
    setCommentCount(null);
    setVendorList([]);
    setVendorInformationForms([VendorInformationFormData]);
    setActiveVendorTab(0);
    setProductInformationFormErrors({});
    setVendorInformationFormErrors([]);
    setHasVendorInformationFormsSubmitted(false);
  }, [
    setActiveVendorTab,
    setCommentCount,
    setHasVendorInformationFormsSubmitted,
    setNewProductInformationForm,
    setProductIdeaData,
    setProductInformationFormErrors,
    setVendorInformationFormErrors,
    setVendorInformationForms,
    setVendorList,
  ]);

  const clearProductSession = useCallback(() => {
    resetFormState();
    setSelectedIdea({
      ideaId: undefined,
      ideaName: "",
      editable: true,
    });
    setIsCommentVisible(false);
    setShowCommentsNLogs(false);
    setCommentsComponentActive("");
  }, [
    resetFormState,
    setCommentsComponentActive,
    setIsCommentVisible,
    setSelectedIdea,
    setShowCommentsNLogs,
  ]);

  return { resetFormState, clearProductSession };
};
